import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import '../styles/Home.scss';
import InstallButton from '../components/InstallButton';

import { useSelector } from 'react-redux';

import { SW_INIT, SW_UPDATE } from '../types';

export default function Home({setView, defferedPrompt, setDefferedPrompt, isIOS}) {

  const state = useSelector(state => state);

  return (
    <Box id="home">
      <InstallButton defferedPrompt={defferedPrompt} setDefferedPrompt={setDefferedPrompt} isIOS={isIOS} />
      <Button
        sx={{marginTop: '5px'}}
        onClick={(e) => setView('collections')}
        className='homeBtn'
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          min-height={'100%'}
          paddingBottom={'90px'}
          flexWrap={'nowrap'}
        >
          <Grid item>
            <img id="logo" style={{width: '95%', maxWidth: "300px"}} src="../images/of-logo.png" alt="The Optical Foundry" />
          </Grid>
          <Grid item>
            <p style={{marginTop: '10px'}}>Independence for Independents</p>
          </Grid>
          <Grid item>
            <Box className='homeFakeBtn'
            >VIEW COLLECTIONS</Box>
          </Grid>
          <Grid item>
            <p style={{width: '95%', maxWidth: "500px", textTransform: "none", marginTop: "50px", fontWeight: "normal", textAlign: "justify", marginLeft: "auto", marginRight: "auto"}}>The Optical Foundry was founded in 2019 on the belief that highly focused, autonomous design voices are the fire that drives the engine of the optical industry. The Optical Foundry nurtures an ecology of distinct brand viewpoints guided by shared goals of originality, craftsmanship, innovation and quality. Focused especially on the needs of independent optical retailers in search of inspiring, cutting-edge options, three compelling free-standing design houses work under the guidance, advocacy, steerage and encouragement of The Optical Foundry. The Optical Foundry serves as a one-stop portal for discovery, built on a foundation of helpful, expert customer service and consistent, reliable delivery. We are thrilled you see the valuable ways in which our mission can amplify your own: to give individuals the opportunity to see things in a different light with inspiring eyewear.</p>
          </Grid>
        </Grid>
      </Button>
    </Box>
  )
}
